const LOGO = 'https://storage.readdy-site.link/project_files/d1b5596e-1952-4672-9c5f-425388885f69/48f0eea8-b2b0-4deb-88e9-031205d0d92a_Design-sem-nome-88.png?v=8ea2ab9a1eb99ec84ac92f6537b4098d';
const HERO_IMG = 'https://storage.readdy-site.link/project_files/d1b5596e-1952-4672-9c5f-425388885f69/8818de03-4013-43a9-827d-3f4b09b2aa94_Design-sem-nome-81.png?v=da3036de095929c8f71fab1589a36726';

const links = [
    {
        id: 'whatsapp',
        label: 'Agendar Consulta',
        sublabel: 'Fale pelo WhatsApp',
        href: 'https://wa.me/5555996946460?text=Olá,%20vim%20pelo%20Google%20e%20quero%20agendar%20consulta',
        icon: 'ri-whatsapp-line',
        bg: 'linear-gradient(135deg, #2a5c3a 0%, #3d7a52 100%)',
        textColor: '#fff',
        border: false,
    },
    {
        id: 'instagram-dra',
        label: 'Instagram da Dra. Mari',
        sublabel: '@dra_mariescobar',
        href: 'https://www.instagram.com/dra_mariescobar/',
        icon: 'ri-instagram-line',
        bg: 'linear-gradient(135deg, #4a3050 0%, #7a3a3a 100%)',
        textColor: '#fff',
        border: false,
    },
    {
        id: 'clinica',
        label: 'Clínica Moriah',
        sublabel: '@clinica_moriahsb',
        href: 'https://www.instagram.com/clinica_moriahsb',
        icon: 'ri-instagram-line',
        bg: 'linear-gradient(135deg, #3D4A38 0%, #5c6b55 100%)',
        textColor: '#fff',
        border: false,
    },
    {
        id: 'site',
        label: 'Meu Site',
        sublabel: 'Conheça meu trabalho',
        href: '/',
        icon: 'ri-global-line',
        bg: 'rgba(255,255,255,0.08)',
        textColor: '#e8ede6',
        border: true,
    },
];

export default function LinksPage() {
    return (
        <div className="min-h-screen flex flex-col items-center relative overflow-hidden">

            {/* Background: foto da Dra. inteira */}
            <div className="fixed inset-0 w-full h-full z-0">
                <img
                    src={HERO_IMG}
                    alt=""
                    className="w-full h-full object-cover object-center"
                />
                {/* Overlay escuro suave para legibilidade */}
                <div
                    className="absolute inset-0"
                    style={{ background: 'linear-gradient(180deg, rgba(30,38,28,0.55) 0%, rgba(30,38,28,0.70) 50%, rgba(20,28,20,0.85) 100%)' }}
                />
            </div>

            {/* Conteúdo */}
            <div className="relative z-10 w-full flex flex-col items-center">

                {/* Profile Header */}
                <div className="w-full flex flex-col items-center pt-14 pb-6 px-6">

                    {/* Avatar com novo logo */}
                    <div className="relative mb-4">
                        <div
                            className="w-24 h-24 rounded-full p-[3px]"
                            style={{ background: 'linear-gradient(135deg, #A8B5A0, #fff 60%, #6B705C)' }}
                        >
                            <div className="w-full h-full rounded-full overflow-hidden bg-[#2C3328] flex items-center justify-center">
                                <img
                                    src={LOGO}
                                    alt="Dra. Mari Escobar"
                                    className="w-full h-full object-contain p-1"
                                />
                            </div>
                        </div>
                        {/* Online dot */}
                        <div className="absolute bottom-1 right-1 w-4 h-4 rounded-full bg-[#3d7a52] border-2 border-[#2C3328]"></div>
                    </div>

                    {/* Nome e info */}
                    <div className="flex flex-col items-center gap-1">
                        <h1
                            className="text-white text-xl font-bold tracking-tight text-center"
                            style={{ fontFamily: "'Playfair Display', serif" }}
                        >
                            Dra. Mari Escobar
                        </h1>
                        <p className="text-white/60 text-xs tracking-widest uppercase">CRM 63381</p>
                        <div className="flex items-center gap-2 mt-2 flex-wrap justify-center">
                            <span className="bg-white/10 text-white/80 text-xs px-3 py-1 rounded-full border border-white/10">
                                Medicina Integrativa
                            </span>
                            <span className="bg-white/10 text-white/80 text-xs px-3 py-1 rounded-full border border-white/10">
                                Longevidade
                            </span>
                        </div>
                        <div className="flex items-center gap-1 mt-2">
                            <div className="w-4 h-4 flex items-center justify-center">
                                <i className="ri-map-pin-2-line text-white/40 text-xs"></i>
                            </div>
                            <span className="text-white/40 text-xs">São Borja – RS</span>
                        </div>
                    </div>

                    {/* Divider */}
                    <div className="w-16 h-px bg-white/20 mt-6"></div>
                </div>

                {/* Links */}
                <div className="w-full max-w-xs px-5 pb-10 flex flex-col gap-3">
                    {links.map((link) => (
                        <a
                            key={link.id}
                            href={link.href}
                            target={link.id === 'whatsapp' ? '_self' : (link.href.startsWith('http') ? '_blank' : '_self')}
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                if (link.id === 'whatsapp') {
                                    e.preventDefault();

                                    if (typeof gtag_report_conversion === 'function') {
                                        gtag_report_conversion(link.href);
                                    } else {
                                        window.location.href = link.href;
                                    }
                                }
                            }}
                            className="flex items-center gap-4 px-5 py-4 rounded-2xl cursor-pointer transition-transform duration-200 active:scale-95 hover:scale-[1.02]"
                            style={{
                                background: link.bg,
                                border: link.border ? '1.5px solid rgba(255,255,255,0.15)' : 'none',
                                boxShadow: link.border ? 'none' : '0 4px 20px rgba(0,0,0,0.25)',
                            }}
                        >
                            <div
                                className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                                style={{
                                    background: link.border ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.18)',
                                }}
                            >
                                <i
                                    className={`${link.icon} text-xl`}
                                    style={{ color: link.border ? '#A8B5A0' : '#fff' }}
                                ></i>
                            </div>
                            <div className="flex-1 min-w-0">
                                <p
                                    className="text-sm font-semibold whitespace-nowrap"
                                    style={{ color: link.textColor }}
                                >
                                    {link.label}
                                </p>
                                <p
                                    className="text-xs mt-0.5"
                                    style={{ color: link.border ? 'rgba(232,237,230,0.55)' : 'rgba(255,255,255,0.65)' }}
                                >
                                    {link.sublabel}
                                </p>
                            </div>
                            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                                <i
                                    className="ri-arrow-right-s-line text-lg"
                                    style={{ color: link.border ? 'rgba(168,181,160,0.5)' : 'rgba(255,255,255,0.5)' }}
                                ></i>
                            </div>
                        </a>
                    ))}
                </div>

                {/* Footer */}
                <div className="pb-8 flex flex-col items-center gap-1">
                    <p className="text-white/20 text-xs">© {new Date().getFullYear()} Dra. Mari Escobar</p>
                </div>

            </div>
        </div>
    );
}
